import styled from "@emotion/styled";

export const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  overflow: hidden;
`;
